import React, { Component } from 'react';
import services from '../../services/allservices.jsx'
import InputMask from 'react-input-mask';
import RaisedButton from 'material-ui/RaisedButton';
import creditcardlogo from '../../images/credit-cards-vector-icon-.jpg'
import { ToastContainer, toast } from 'react-toastify';
import Loader from '../loader/loader.jsx'
import { withRouter } from 'react-router-dom'
import { connect } from 'react-redux';
import * as actions from '../../actions/actions.jsx'
import LoaderSmall from "../loader/loadersmall.jsx"
import TextField from 'material-ui/TextField';
const styles = {
    button: {
        // margin: 12,
        marginTop: 20,
        background: "#2a5194"
    },
    exampleImageInput: {
        cursor: 'pointer',
        position: 'absolute',
        top: 0,
        bottom: 0,
        right: 0,
        left: 0,
        width: '100%',
        opacity: 0,
    },
    customWidth: {
        width: 150,
    },
    focusStyle: {
        borderTop: "none #333",
        borderLeft: "none #333",
        borderRight: "none #333",
        borderBottom: "2px solid #333"
    },
    focusTextStyle: {
        color: "#333"
    }
};

const mapStateToProps = state =>
    ({
        publicKey: state.publicKey.publicKey,
        keyRecieved: state.publicKey.keyRecieved,
        activationcardState:state.getactivationcardReducer.activationcardState
    })
const mapDispatchToProps = dispatch =>
    ({
        fetchPublicKey(keyRecieved) {
            dispatch(
                actions.publicKeyAction(keyRecieved)
            )
        },
        storeCardNumber(cardNumber) {
            dispatch(
                actions.storeCardDetail(cardNumber)
            )
        },
        getactivation(state) {
           
            dispatch(
                actions.getactivationcardAction(state)
    
            )
        },
    })


const JSEncrypt = window.JSEncrypt
class CardNumber extends Component {
    constructor(props) {
        super(props);
        this.state = {
            cardVerificationDone: false,
            mobileVerificationDone: false,
            mobiledisable:true,
            disabled:true,
            expiryDone: false,
            cardVerified: false,
            verification: false,
            rederFeedback: false,
            mobilecardVerified: false,
            mobileverification: false,
            mobilerederFeedback: false,
            mobile: '',
            loader: false,
            title:"Please enter valid card number"
        }
        this.storeCard = this.storeCard.bind(this)
    }
   
    componentDidMount() {
        // React.findDOMNode(this.refs.item.focus())
        if(localStorage.getItem('landingTabs')==='cardNo'){
            document.getElementById("cardNumber").focus()
        }
        this.props.fetchPublicKey(false)

    }
    handlediable = () => {
       
            if (this.state.verification === true && this.state.verification === true) {
                this.setState({
                    disabled:false 

                })
            }
            else {
                this.setState({
                    disabled: true
                })
            }

        
    }
    storeCard() {
        const { publicKey } = this.props
        const {cardno}= this.state
        let _this = this;
        this.setState({
            loader: true
        })
        // this.props.history.push('/activate-card')
        if (this.state.mobileVerificationDone && this.state.cardVerificationDone) {
            this.setState({
                disabled:false 

            })
            const state = {
                cardNumber: this.state.cardNumber,
                applicationId: "gmcabs"
            }
            if(this.state.cardStatus==="A"){
                fetch(services.store_card, {
                    method: 'POST',
                    headers: new Headers({
                        'Content-Type': 'application/json',
                    }),
                    body: JSON.stringify(state)
                })
                    .then(response => {
                        if (response.status === 200 || response.status === 201) {
                            response.json().then(function (object) {
                                _this.setState({
                                    loader: false
                                })
                                localStorage.setItem("updateSecurityInfo", object.updateSecurityInfo)
                                localStorage.setItem("status", object.cardStatus)
                                let step= 0
                               JSON.stringify(localStorage.setItem("step",step)) 
                                _this.props.history.push('/activate-card')
                            })
                        } else {
                            _this.setState({
                                loader: false
                            })
                        }
                    })
                    

            }

            else{
               
                if(cardno.length!= 0){
                    this.setState({ cardVerified: true, rederFeedback: false })
                 
                    if (publicKey.status === 200) {
                        const public_Key = publicKey.body.publickey;
                        let encrypt = new JSEncrypt();
                        encrypt.setPublicKey(public_Key);
                        let encrypted = encrypt.encrypt(cardno);
                        this.props.storeCardNumber(encrypted)
                        localStorage.setItem("cardNumber", encrypted)
                        this.setState({ cardNumber: encrypted })
                        const state = {
                            cardNumber: encrypted,
                            applicationId: "gmcabs"
                        }
            
                        fetch(services.verify_card, {
                            method: 'POST',
                            headers: new Headers({
                                'Content-Type': 'application/json',
                            }),
                            body: JSON.stringify(state)
                        })
                            .then(response => {
                                if (response.status === 200 || response.status === 201) {
                                    response.json().then(function (object) {
                                        _this.setState({ cardVerified: false, rederFeedback: true, verification: true, cardVerificationDone: true,})
                                     
                                        let mobile = object.mobileNumber
                                        let res = mobile.substring(mobile.length - 4, mobile.length);
            
                                        _this.setState({ mobile: res })
                                        localStorage.setItem("status", object.cardStatus)
                                        let step= 1
                                        JSON.stringify(localStorage.setItem("step",step)) 
                                        _this.props.history.push('/activate-card')
                                    })
                                } else {
                                   
                                    _this.setState({ cardVerified: false, rederFeedback: true ,loader:false })
                                    toast.error(response.headers.get('message'), {
                                        position: "top-right",
                                        draggablePercent: 60,
                                        autoClose: 3000,
                                        hideProgressBar: false,
                                        closeOnClick: true,
                                        pauseOnHover: true,
                                        draggable: false
                                    });
            
                                }
                            })
                    }
                     }
                        else{
                            toast.error(('please enter card number'), {
                                position: "top-right",
                                draggablePercent: 60,
                                autoClose: 3000,
                                hideProgressBar: false,
                                closeOnClick: true,
                                pauseOnHover: true,
                                draggable: false
                            });
                        }

            }
            

        }
        else {
            this.setState({
                disabled:true 

            })
            toast.error('Please fill valid data'), {
                position: "top-right",
                draggablePercent: 60,
                autoClose: 3000,
                hideProgressBar: false,
                closeOnClick: true,
                pauseOnHover: true,
                draggable: false
            };
            setTimeout(function () {
                window.location.reload(1);
            }, 3000);
        }

    }
    checkCardNumber(e) {
        let _this = this
        let string = e.target.value;
        const cardNumber = string.replace(/-/g, "");
        const actualCardNumber = cardNumber.replace(/_/g, "");
        

        const { publicKey } = this.props
        if(actualCardNumber.length >= 16){
           
            if(!actualCardNumber.startsWith('48138122')){
                toast.error(('Invalid Card Number'), {
                    position: "top-right",
                    draggablePercent: 60,
                    autoClose: 3000,
                    hideProgressBar: false,
                    closeOnClick: true,
                    pauseOnHover: true,
                    draggable: false
                });
                return ;
            }
           
        this.setState({ cardVerified: true, rederFeedback: false , cardno: cardNumber ,mobiledisable: true ,title:"Please enter valid card number"})
     
        if (publicKey.status === 200) {
            const public_Key = publicKey.body.publickey;
            let encrypt = new JSEncrypt();
            encrypt.setPublicKey(public_Key);
            let encrypted = encrypt.encrypt(cardNumber);
            this.props.storeCardNumber(encrypted)
            localStorage.setItem("cardNumber", encrypted)
            this.setState({ cardNumber: encrypted })
            const state = {
                cardNumber: encrypted,
                applicationId: "gmcabs"
            }

            fetch(services.verify_card, {
                method: 'POST',
                headers: new Headers({
                    'Content-Type': 'application/json',
                }),
                body: JSON.stringify(state)
            })
                .then(response => {
                    if (response.status === 200 || response.status === 201) {
                       
                        response.json().then(function (object) {
                           
                            _this.setState({ cardVerified: false, rederFeedback: true, verification: true, mobiledisable:false, title:'' , cardVerificationDone: true,
                            cardStatus: object.cardStatus })

                            let mobile = object.mobileNumber
                            
                            let res = mobile.substring(mobile.length - 4, mobile.length);

                            _this.setState({ mobile: res })
                            let state = {
                                cardNumber: object.cardNumber,
                                expiryDate: object.expiryDate,
                                firstName: object.firstName,
                                lastName: object.lastName
                            }
                            localStorage.setItem("accountId", object.accountId)
                            _this.props.getactivation(state)


                        })
                            
                        
                        
                        
                    } else {
                        _this.setState({ cardVerified: false, rederFeedback: true, verification: false ,mobiledisable:true, title:"Please enter valid card number"})
                        toast.error(response.headers.get('message')), {
                            position: "top-right",
                            draggablePercent: 60,
                            autoClose: 3000,
                            hideProgressBar: false,
                            closeOnClick: true,
                            pauseOnHover: true,
                            draggable: false
                        };

                    }
                })
        }
         }
            else { 
                if(actualCardNumber.length !== 0)
                toast.error(('please enter valid card number'), {
                    position: "top-right",
                    draggablePercent: 60,
                    autoClose: 3000,
                    hideProgressBar: false,
                    closeOnClick: true,
                    pauseOnHover: true,
                    draggable: false
                });
            }

    }
    checkMobileNumber(e) {
        if (e.target.value !== "") {
            this.setState({ mobilecardVerified: true, mobilerederFeedback: false })
            if (e.target.value === this.state.mobile) {
                this.setState({ mobilecardVerified: false, mobilerederFeedback: true, mobileverification: true, mobileVerificationDone: true })
            } else {
                this.setState({ mobilecardVerified: false, mobilerederFeedback: true, mobileverification: false })
            }
        }
    }
    render() {
        const { cardVerified, loader, verification, rederFeedback, mobilecardVerified, mobileverification, mobilerederFeedback } = this.state
        const {activationcardState} = this.props
       
        return (
            <div>
                
                {loader ? <div>
                        <Loader />
                    </div> :
                <div className="cardno">
                    <div className="col-sm-12">
                        <div className="row input-group" >
                            <div className="offset-md-2 col-sm-1 group-icon" >
                                <img src={creditcardlogo} alt="" />
                                {/* <i className="fa fa-credit-card-alt text-dark " aria-hidden="true"></i> */}
                            </div>
                            <div className="col-sm-6" style={{marginLeft:"15px" ,padding:"8px"}}>

                                <div className="group">
                                    <InputMask mask="9999-9999-9999-9999" onChange={this.handlediable} placeholder="1234-1234-1234-1234" onBlur={this.checkCardNumber.bind(this)} 
                                   id="cardNumber" ref="item"/>
                                    <span className="highlight"></span>
                                    <span className="bar"></span>
                                    <label>Enter Card Number</label>
                                </div>
                            </div>
                            <div className="col-sm-2">
                                {cardVerified ? <LoaderSmall /> : null}
                                {rederFeedback ? <div className="feedback">
                                    {verification ? <i className="fa fa-check" aria-hidden="true" style={{ color: "green", marginLeft: "3px" }}></i> :
                                        <i className="fa fa-times" aria-hidden="true" style={{ color: "red" }}></i>}
                                </div> : null}

                                {/*  */}
                            </div>
                        </div>
                        <div className="row">
                            <div className="offset-md-2 col-sm-1 group-icon">
                                <i className="fa fa-mobile text-dark " aria-hidden="true" style={{ fontSize: "34px" ,right:"-7px" }}></i>
                            </div>
                            <div className="col-sm-6">
                            <label style={{ fontSize: "14px" ,marginLeft:"10px" }}>Phone Number</label>
                                <div className="group"  style={{marginTop:"0px" }}>
                               
                                    <InputMask mask="9999" placeholder="Last 4 Digit" title={this.state.title} readOnly={this.state.mobiledisable} onChange={this.handlediable} onBlur={this.checkMobileNumber.bind(this)} />
                                    
                                    
                                </div>
                            </div>
                            <div className="col-sm-2">
                                {mobilecardVerified ? <LoaderSmall /> : null}
                                {mobilerederFeedback ? <div className="feedback">
                                    {mobileverification ? <i className="fa fa-check" aria-hidden="true" style={{ color: "green" }}></i> :
                                        <i className="fa fa-times" aria-hidden="true" style={{ color: "red" }}></i>}
                                </div> : null}
                            </div>
                            {/* <div className="col-sm-1 group-icon">
                        <i className="fa fa-calendar text-dark " aria-hidden="true" ></i>
                    </div>
                    <div className="col-sm-4">
                        <div className="group">
                            <InputMask mask="99/99" placeholder="12/18" />
                            <span className="highlight"></span>
                            <span className="bar"></span>
                            <label>Expiration Date</label>
                        </div>
                    </div> */}
                        </div>
                        <div className="row input-group">
                            <div className="offset-md-5 ">
                                <RaisedButton
                                    label="Submit"
                                    disabled={this.state.disabled}
                                    className="card-submit"
                                    backgroundColor="#333"
                                    labelColor="#fff"
                                    
                                    onClick={this.storeCard}
                                />
                               
                            </div>

                        </div>
                        </div>
                </div>}
            </div>
            
                );
            }
        }

// CardNumber.propTypes = {
                    //     publicKey: PropTypes.object,
                    //     keyRecieved: PropTypes.bool
                    // };
                    CardNumber.defaultProps = {
                        keyRecieved: false
                    };

                export default withRouter(connect(mapStateToProps, mapDispatchToProps)(CardNumber));


// WEBPACK FOOTER //
// ./src/components/register/cardnumber.jsx